import { render } from "./KDDIMaizuru.vue?vue&type=template&id=02613862&ts=true"
import script from "./KDDIMaizuru.vue?vue&type=script&lang=ts"
export * from "./KDDIMaizuru.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/user/Desktop/kafka/paletteiot/pletteiotweb/PaletteIoTDashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__